var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navigation-overlay bg-dark",
      class: { active: _vm.$root.navigationIsVisble }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "navigation-overlay-inner h-100 d-lg-flex flex-column justify-content-center"
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }